// 系统配置
module.exports = {
  title: "商城",
  // 是否开启vuex缓存
  vuexStorage: true,
  // 是否开启localStorage
  localStorage: true
};
